import api from './api'

const options = { timeout: 45000 }
export const codexAPI = {
  status: () => api.get('/codex'),
  audit: params => api.get('/codex/audit', { params }),
  auditDetail: eventId => api.get(`/codex/audit/${encodeURIComponent(eventId)}`),
  connect: () => api.post('/codex/connect', {}, options),
  disconnect: () => api.delete('/codex/connection', options),
  send: text => api.post('/codex/messages', { text }, options),
  stop: () => api.post('/codex/stop', {}, options),
  newChat: () => api.post('/codex/new-chat', {}, options),
  approve: (id, approved) => api.post(`/codex/approvals/${encodeURIComponent(id)}`, { approved }, { timeout: 150000 }),
}
